import React, { memo, useContext } from 'react';
import { FaCaretRight, FaQuestionCircle } from 'react-icons/fa';
import ScreenContext from '../../../../responsive/context';
import { ErrorMessageContainer, FormInputContainer, Heading, InputContainer, LeftContainer, NormalizeOffsetContainer, SubHeading, Tooltip, TooltipIconContainer, } from './styles';
import ErrorStrip from '../strips/error-strip';
import WarningStrip from '../strips/warning-strip';
import { useHover } from '../../../../hooks/use-hover';
var FormInput = function (_a) {
    var label = _a.label, subtext = _a.subtext, tooltip = _a.tooltip, name = _a.name, error = _a.error, warning = _a.warning, touched = _a.touched, children = _a.children, headingChildren = _a.headingChildren;
    var isDesktop = useContext(ScreenContext).isDesktop;
    var _b = useHover(!isDesktop), tooltipIconRef = _b[0], isTooltipIconBeingHovered = _b[1];
    var _hasError = !!error && !!touched;
    var _hasWarning = !!warning && !!touched;
    var _hasTooltip = !!tooltip;
    return (React.createElement(NormalizeOffsetContainer, { "data-name": name },
        React.createElement(FormInputContainer, { strip: _hasError || _hasWarning },
            !!label && (React.createElement(Heading, { hasWarning: _hasWarning, hasError: _hasError },
                React.createElement(LeftContainer, null,
                    (_hasError || _hasWarning) && React.createElement(FaCaretRight, null),
                    label,
                    _hasTooltip && (React.createElement(TooltipIconContainer, { ref: tooltipIconRef },
                        React.createElement(FaQuestionCircle, null)))),
                React.createElement("div", null, headingChildren))),
            !!subtext && React.createElement(SubHeading, null, subtext),
            _hasTooltip && isTooltipIconBeingHovered && React.createElement(Tooltip, null, tooltip),
            React.createElement(InputContainer, null, children),
            React.createElement(ErrorMessageContainer, null, touched &&
                (error ? React.createElement(ErrorStrip, { content: error }) : warning ? React.createElement(WarningStrip, { content: warning }) : null)))));
};
export default memo(FormInput);
